webpackJsonp([100248026755231],{

/***/ 1954:
/***/ (function(module, exports) {

	module.exports = {"data":{"doc":{"id":"/docs/providers/aws/cli-reference/login/","frontmatter":{"title":"Serverless Framework Commands - Login","menuText":"login","layout":"Doc","menuOrder":11,"gitLink":"/docs/providers/aws/cli-reference/login.md","description":"Login to the serverless platform","menuItems":null},"content":"<h1 id=\"login\"><a href=\"#login\" class=\"phenomic-HeadingAnchor\">#</a>Login</h1>\n<p>The <code>login</code> command logs users into the serverless platform.</p>\n<p>It will create a new serverless platform account if one doesn't already exist.</p>\n<pre><code class=\"hljs language-bash\">serverless login\n\n<span class=\"hljs-comment\"># Shorthand</span>\nsls login</code></pre>\n"}},"pathContext":{"docId":"/docs/providers/aws/cli-reference/login/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---framework-docs-providers-aws-cli-reference-login-12e86dbfc5e508afcbd4.js